import { render, staticRenderFns } from "./ProductionAreas.vue?vue&type=template&id=2a27561a&lang=pug&"
import script from "./ProductionAreas.vue?vue&type=script&lang=js&"
export * from "./ProductionAreas.vue?vue&type=script&lang=js&"
import style0 from "./ProductionAreas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports